module.exports = ".homeCollection {\n  will-change: transform; }\n  .homeCollection .item {\n    will-change: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home/home.component.scss
// module id = ./src/app/home/home/home.component.scss
// module chunks = main